export function EmployeesPage () {
  return (
    <div>
      <h1 className='heading-lg mb-6'>Employees</h1>
    </div>
  )
}
